import { FC, Fragment, memo, useState } from "react";

import { Close } from "@carbon/icons-react";
import { ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Divider } from "@/components/ui/divider";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { GroupPathsEnum } from "@/features/groups/constants/group.paths";
import { GroupStructureDetailDef } from "@/features/groups/types/group.type";

type GroupStructureDetailProps = {
  open: boolean;
  close: () => void;
  group?: GroupStructureDetailDef;
};
const GroupStructureDetailSheet: FC<GroupStructureDetailProps> = ({
  open,
  close,
  group,
}) => {
  const navigate = useNavigate();

  const [showMore, setShowMore] = useState(false);
  if (!group) {
    return null;
  }
  return (
    <Sheet
      open={open}
      onOpenChange={close}
    >
      <SheetContent className="sm:max-w-[500px] px-6 text-sm">
        <div className="flex gap-3 pb-6">
          <Avatar className="size-10">
            <AvatarImage src={group.photoUrl} />
            <AvatarFallback>{group.groupName.charAt(0)}</AvatarFallback>
          </Avatar>
          <div>
            <p className="truncate w-[368px] mb-0 text-sm font-semibold text-secondary-900">
              {group.groupName}
            </p>
            <span className="text-secondary-600 text-xs">
              {group.numberOfMembers} Thành viên
            </span>
          </div>
          <div className=" ">
            <Close
              className="cursor-pointer"
              size={20}
              onClick={close}
            />
          </div>
        </div>
        <div className="mb-6 flex">
          <Button
            variant={"ghost"}
            className="flex-1"
            onClick={() =>
              navigate(
                GroupPathsEnum.GROUP_TREE.replace(/:id/, group.groupId + "")
              )
            }
          >
            Truy cập nhóm
          </Button>
        </div>
        <p className="font-medium mb-2">Giới thiệu</p>
        <p>
          <span
            dangerouslySetInnerHTML={{
              __html: group.description,
            }}
          />
          {/* <span className="font-medium cursor-pointer"> Ẩn bớt</span> */}
        </p>
        <Divider orientation="vertical" />
        <div className="font-medium mb-5">Thông tin cơ bản</div>
        <div className="grid grid-cols-2">
          {group.groupAttributes
            .slice(0, !showMore ? 3 : group.groupAttributes.length)
            .map((attribute) => (
              <Fragment key={attribute.key}>
                <div className="py-2">{attribute.label}</div>
                <div className="py-2 font-medium">{attribute.value}</div>
              </Fragment>
            ))}
        </div>
        {group.groupAttributes.length > 3 && (
          <Button
            variant="text"
            className="-ml-4"
            size="sm"
            onClick={() => setShowMore(!showMore)}
          >
            <ChevronDown size={16} />
            {showMore ? "Ẩn bớt" : "Xem thêm"}
          </Button>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default memo(GroupStructureDetailSheet);
